export default __webpack_public_path__ + "static/media/collection-img-sample3.10c6813b.png";